import React, { Component, useRef, useContext } from "react";
import { Map, TileLayer, Popup, Marker, withLeaflet, LayersControl } from "react-leaflet";
import Paper from '@material-ui/core/Paper';
import {MdMyLocation} from "react-icons/md";
import { InputAdornment, IconButton, Input} from '@material-ui/core';
import IsMobileContext from "../../../context/isMobile/isMobileContext";

const MyMarker = props => {
    const initMarker = ref => {
        if (ref) {
            ref.leafletElement.openPopup()
        }
    }
    return <Marker ref={initMarker} {...props} />
}

export default function InfoMap({rowData,center,selected,zoom,open}) {
    const isMobile = useContext(IsMobileContext);
    const { isMobileUse } = isMobile;
    const mapaRef = useRef('map');
    const centrar = () => {mapaRef.current.leafletElement.flyTo(center, 15)}
    return (
        <>
        {isMobileUse() ?
            <Paper style={{ height: "350px", width: "270px", borderRadius:"15px", position:"relative" }}>
                <div
                    style={{
                        border: "2px solid rgba(0,0,0,0.2)",
                        borderRadius: "4px",
                        position: "absolute",
                        bottom: "10%",
                        right: "5%",
                        zIndex: "999",
                        backgroundColor: "white",
                        padding: "0px",
                    }}
                >
                    <IconButton
                        style={{ padding: "4px", color: "#414141" }}
                        onClick={() => { centrar() }}
                    >
                        <MdMyLocation />
                    </IconButton>
                </div>
                {open ?
                <Map
                    style={{ height: "100%", width: "100%",borderRadius:"15px" }}
                    center={center}
                    zoom={zoom}
                    ref={mapaRef}
                >
                    <LayersControl>
                        <LayersControl.BaseLayer name="Satelital" checked>
                            <TileLayer
                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" // satelital
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name="Base" >
                            <TileLayer
                                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" //base
                            />
                        </LayersControl.BaseLayer>
                    </LayersControl>
                    <MyMarker position={selected}>
                    <Popup>
                            <p>Lat: {rowData.latitud}</p>
                            <p>Lng: {rowData.longitud}</p>
                    </Popup>
                    </MyMarker>
                </Map>:<></>}
            </Paper>
            :
            <Paper style={{ height: "100%", width: "100%", borderRadius:"15px", position:"relative" }}>
                <div
                    style={{
                        border: "2px solid rgba(0,0,0,0.2)",
                        borderRadius: "4px",
                        position: "absolute",
                        bottom: "10%",
                        right: "5%",
                        zIndex: "999",
                        backgroundColor: "white",
                        padding: "0px",
                    }}
                >
                    <IconButton
                        style={{ padding: "4px", color: "#414141" }}
                        onClick={() => { centrar() }}
                    >
                        <MdMyLocation />
                    </IconButton>
                </div>
                {open ?
                <Map
                    style={{ height: "100%", width: "100%",borderRadius:"15px" }}
                    center={center}
                    zoom={zoom}
                    ref={mapaRef}
                >
                    <LayersControl>
                        <LayersControl.BaseLayer name="Satelital" checked>
                            <TileLayer
                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" // satelital
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name="Base" >
                            <TileLayer
                                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" //base
                            />
                        </LayersControl.BaseLayer>
                    </LayersControl>
                    <MyMarker position={selected}>
                    <Popup>
                            <p>Lat: {rowData.latitud}</p>
                            <p>Lng: {rowData.longitud}</p>
                    </Popup>
                    </MyMarker>
                </Map>:<></>}
            </Paper>
        }
        </>
    )
}

